import React, { useContext, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import { Container } from 'react-bootstrap';
//import portalIcon from '../assets/portal.svg';
import GoogleSignInButton from '../components/GoogleSignInButton';
import './Home.css';

const STORE_API_URL = process.env.REACT_APP_API_URL;

const HomeAuthenticated = () => {
  const { token, isAuthenticated } = useContext(AuthContext);
  const [settings, setSettings] = useState({
    onboarding: {
      store_created: false,
      store_logo_uploaded: false,
      store_address_entered: false,
      store_custom_domain_setup: false,
      store_converted: false,
      store_policy: false,
      product_showcase_created: false,
      product_showcase_published: false,
      product_sale_created: false,
      product_sale_published: false,
      product_repaired: false,
      product_sold: false,
      approved_beambender: false,
      email_sending_enabled: false,
    },
    stripeAccountId: '',
    stripeAccountCreatedAt: '',
    stripeOnboardingComplete: '',
    stripeOnboardingCompletedAt: '',
    stripeAccountDetailsSubmitted: '',
    stripeAccountPayoutsEnabled: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (token) {
      fetchSettings();
    }
  }, [token]);

  const fetchSettings = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(`${STORE_API_URL}/settings`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error('Error fetching settings.');
      }

      const data = await response.json();

      //console.log('Settings data: ' + JSON.stringify(data));

      // Ensure stripe_accounts exists and has at least one account before accessing properties
      const stripeAccount = data.stripe_accounts && data.stripe_accounts.length > 0 ? data.stripe_accounts[0] : {};

      //console.log('Accounts data: ' + JSON.stringify(stripeAccount));
  
      setSettings({
        onboarding: data.onboarding,
        stripeAccountId: stripeAccount.account_id || '',
        stripeAccountCreatedAt: stripeAccount.created_at || '',
        stripeOnboardingComplete: stripeAccount.onboarding_complete || false,
        stripeOnboardingCompletedAt: stripeAccount.onboarding_completed_at || '',
        stripeAccountDetailsSubmitted: (stripeAccount.account && stripeAccount.account.details_submitted) || '',
        stripeAccountPayoutsEnabled: (stripeAccount.account && stripeAccount.account.payouts_enabled) || ''
      });
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <div className="headline d-flex justify-content-between align-items-center">
        <h2>Dashboard</h2>
      </div>
      <div>
        {loading && <div>Loading...</div>}
        {error && <div style={{ color: 'red' }}>{error}</div>}
        {/* Progress and CTA Section */}
        <div className="timeline-container">
          <div className="vertical-timeline p-4">
            <h5 className="underline mb-4">Your progress</h5>
            <div className="progress-checklist mb-4">
              <ul className="list-unstyled">
                <li className="mb-3 d-flex align-items-center">
                  <div className="circle-checkbox">
                    <input 
                      type="checkbox" 
                      checked={settings.onboarding.store_created || false} 
                      readOnly 
                      className="custom-checkbox"
                    /> 
                  </div>
                  <a href='/settings?addcave=true' className="ms-3">Created a cave</a>
                </li>
                <li className="mb-3 d-flex align-items-center">
                  <div className="circle-checkbox">
                    <input 
                      type="checkbox" 
                      checked={settings.onboarding.product_showcase_created || false} 
                      readOnly 
                      className="custom-checkbox"
                    /> 
                  </div>
                  <a href='/add-showcase' className="ms-3">Created a showcase article</a>
                </li>
                <li className="mb-3 d-flex align-items-center">
                  <div className="circle-checkbox">
                    <input 
                      type="checkbox" 
                      checked={settings.onboarding.product_showcase_published || false} 
                      readOnly 
                      className="custom-checkbox"
                    /> 
                  </div>
                  <span className="ms-3">Published an article</span>
                </li>
              </ul>
            </div>
            
            {/* Add Showcase CTA */}
            <div className="cta-container mt-5">
              <h5>Ready to share your collection?</h5>
              <p>Add your first showcase item to your cave and start sharing your passion.</p>
              <Link to="/add-showcase" className="btn btn-primary mt-3">
                Add To Showcase
              </Link>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default HomeAuthenticated;